export default __webpack_public_path__ + "static/cardsRowDiv2-256d479ba9f9eee0ff98b5aa6a4dfad5.png";